import React from "react";

export default function Heading({ heading }) {
    return <h2 className="mt-4 text-4xl text-center md:text-start md:text-6xl font-extrabold">{heading}</h2>;
}
